import script from "./vm-migration-wizard.vue?vue&type=script&setup=true&lang=js"
export * from "./vm-migration-wizard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__